module.exports = __webpack_public_path__ + "static/media/wakame.ac98582a.png";